import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import React from 'react'
import styled from 'styled-components'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import { capitalise } from 'lib/string/stringUtils'

export const AccommodationIndividualRoomTileHeaderContainer = styled(VerticalSpacer)``

type Props = {
  offer: App.HotelOffer | App.BedbankOffer
  heading: string
  packageNumber?: number
  room: OfferPageRoom
}

function AccommodationIndividualRoomTileHeader(props: Props) {
  const {
    offer,
    packageNumber,
    heading,
    room,
  } = props

  return <AccommodationIndividualRoomTileHeaderContainer gap={12}>
    {!!packageNumber && <div>
      <StructureLabel variant="dark">
        {capitalise(offer.saleUnit)} {packageNumber}
      </StructureLabel>
    </div>}
    <div>
      <Heading variant="heading4">
        {heading}
      </Heading>
      <BodyText variant="medium" colour="neutral-three">
        {formatOccupantsShort(room)}
      </BodyText>
    </div>
  </AccommodationIndividualRoomTileHeaderContainer>
}

export default AccommodationIndividualRoomTileHeader
